import { render, staticRenderFns } from "./PaymentPrice.vue?vue&type=template&id=b099a240&scoped=true&"
import script from "./PaymentPrice.vue?vue&type=script&lang=js&"
export * from "./PaymentPrice.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPrice.vue?vue&type=style&index=0&id=b099a240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b099a240",
  null
  
)

export default component.exports